import { FloraButton } from '@grupoboticario/flora-react';
import { LocationPinIcon } from '@grupoboticario/flora-react-icons';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import slugify from 'slugify';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import config from 'config';
import { BRANDS } from 'config/environments/shared';
import { APP_PATHS } from 'routes';
import { ACCESS_TOKEN_KEY_CADASTRAL_CHANGE } from 'services/auth';
import { useGlobalContext } from 'store';

import type { ActionsParams } from '../Actions';

export const GoToResellerPlaces = ({ hierarchy }: ActionsParams) => {
  const navigate = useNavigate();
  const { brand: environmentBrand } = useGlobalContext();
  const isEud = BRANDS.EUD === environmentBrand.short;
  const url = isEud ? APP_PATHS.RESELLER_PLACE_EUD : APP_PATHS.RESELLER_PLACE_BOT;
  const linkTitle = `Consultar Espaço do ${config.communication.userNamingConvention.singular}`;
  const linkTitleFormatted = slugify(linkTitle, {
    lower: true,
    replacement: '-',
  });

  const handleOnClick = () => {
    Cookies.remove(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);
    navigate(url, { replace: true });
  };

  return (
    <FloraButton
      autotagging-flora='on'
      data-flora='button'
      data-flora-text={linkTitleFormatted}
      hierarchy={hierarchy}
      has='iconLeft'
      icon={<LocationPinIcon size='16' aria-hidden />}
      onClick={handleOnClick}
    >
      <ResponsiveFloraTypography fontWeight='bold'>{linkTitle}</ResponsiveFloraTypography>
    </FloraButton>
  );
};
